import { useState, useEffect } from "react";
import FlatList from "flatlist-react";
import { useTranslation } from "react-i18next";
import * as Action from "@mywvglobal-shared/mywv-shared/action/worldAction";
import { useDispatch, useSelector } from "react-redux";
import SingleChildMarkerView from "../../organism/singleChildMarkerView";
import SearchViewComponent from "../../molecule/searchView";
import SEARCHWHITE from "../../../images/search-icon-grey.svg";
import Modal from "react-bootstrap/Modal";
import { ChildList, ChildListContainer, ChildSearchCloseIcon, RegionName } from "./childSearch";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../utilities/tokenizer";
import { diffYMDHMS } from "../../../utilities/dateUtilities";

const styles = {
  iconsearchstyle: {
    height: "15px",
    width: "15px",
    marginLeft: "10px",
  },
  inputstyle: {
    color: "#000",
    fontSize: "14px",
    fontFamily: "Lato-Bold",
    paddingVertical: 0,
  },
  searchImg: {
    marginLeft: "10px",
  },
  noDataViewStyles: { flex: 1, justifyContent: "center", alignItems: "center" },
  noDataStyles: {
    color: "#000",
    textAlign: "center",
    fontFamily: "Lato-Bold",
  },
}

function ChildSearchView(props) {

  const { t } = useTranslation();
  const { worldReducer } = useSelector((state) => state);
  const childGroupList = props?.childGroupList;
  const isFromGroup = props?.isFromGroup;
  const groupTitle = props?.subRegionName;
  const [filteredChildList, setFilteredChildList] = useState(null);
  const [originalChildList, setOriginalChildList] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isFromGroup) {
      if (childGroupList && childGroupList.length > 0) {
        setFilteredChildList(childGroupList);
        setOriginalChildList(childGroupList);
      }
    } else if (worldReducer?.childList) {
      setFilteredChildList(worldReducer?.childList);
    }
  }, [childGroupList]);
  // code for sorting
  const sortChildren = (children) => {
    let celebratedChild = children.filter(
      (child) => child?.isCelebrationEligible
    );
    celebratedChild = sortData(celebratedChild, "childFirstName");
    let otherChildren = children.filter(
      (child) => !child?.isCelebrationEligible
    );
    otherChildren = sortData(otherChildren, "childFirstName");
    return [...celebratedChild, ...otherChildren];
  };
  const sortData = (data = [], fileName = "name") => {
    if (!data) return [];
    try {
      return data?.sort((a, b) => {
        if (a[fileName] < b[fileName]) {
          return -1;
        }
        if (a[fileName] > b[fileName]) {
          return 1;
        }
        return 0;
      });
    } catch (error) {
      return [];
    }
  };
  const searchChildListValue = (searchText, childListValue) => {
    if (searchText?.trim() === "") {
      return childListValue;
    }
    const filtered = childListValue.filter(
      (item) => (item.childFirstName?.toLowerCase().includes(searchText?.trim().toLowerCase())
        || item.projectName?.toLowerCase().includes(searchText?.trim().toLowerCase())
        || item.countryName?.toLowerCase().includes(searchText?.trim().toLowerCase())),
    );
    return filtered;
  };

  const searchChildList = (searchtext) => {
    if (isFromGroup) {
      setFilteredChildList(
        searchChildListValue(searchtext, originalChildList),
      );
    } else {
      setFilteredChildList(
        searchChildListValue(searchtext, originalChildList),
      );
    }
  };

  const onChildClick = (item) => {
    if (window.location.pathname.includes("/pastSponsoredChild")) {
      if (props?.clickedButton === "connect") {
        navigate(`/connect/${encrypt(item.childCode)}`, { state: { navigateFrom: "station" } })
      } else if (props?.clickedButton === "give") {
        navigate(`/sendAGift/${encrypt(item.childCode)}`, { state: { navigateFrom: "station" } })
      }
    } else if (item?.revealDate) {
      const diffObj = diffYMDHMS(new Date(item?.revealDate), new Date());
      if (diffObj?.days < 0) {
        navigate("/chosen-children/")
      } else {
        navigate(`/chosen-layout/${item?.chosenCorrelationID}`)
      }
    } else {
      const param = {
        selectedChildValues: item,
      };
      dispatch(Action.saveChildDetails(param));
      navigate(`/communityhomeview/${encrypt(item.childCode)}`)
    }
  };

  const renderListItem = (item, index) => (
    <ChildList key={index} onClick={() => onChildClick(item)} className="child-list">
      <SingleChildMarkerView
        childValue={item}
        childProjectCountry={`${item.projectName}, ${item.countryName}`}
        childSearch={true}
      />
    </ChildList>
  );

  const searchIcon = <img src={SEARCHWHITE} style={styles.searchImg} alt="" />;

  const title = (groupTitle) ? (
    <RegionName>{groupTitle}</RegionName>
  ) : (
    null
  );

  return (
    <Modal
      className="child-search-popup"
      show={props?.isVisible}
    >
      <ChildSearchCloseIcon onClick={() => {
        props?.setVisibility();
        searchChildList("");
      }}>
        X
      </ChildSearchCloseIcon>
      <div>
        {title}
        <SearchViewComponent
          searchCallBack={(searchtext) => searchChildList(searchtext)}
          placeholderText={t("SearchName")}
          enableSerach
          placeholderTextColor="#000"
          icon={searchIcon}
          inputstyle={styles.inputstyle}
        />
        <ChildListContainer>
          {(filteredChildList && filteredChildList.length > 0)
            ?
            <FlatList
              list={sortChildren(filteredChildList)}
              renderItem={renderListItem}
              keyExtractor={(item) => item.childCode}
              numColumns={2}
              showsVerticalScrollIndicator={false}
              keyboardShouldPersistTaps="handled"
            />
            :
            <div style={styles.noDataViewStyles}>
              <span style={styles.noDataStyles}>{t("NoResults")}</span>
            </div>
          }
        </ChildListContainer>
      </div>
    </Modal>
  );
}

export default ChildSearchView;
